import { useParams } from "react-router";
import { CreateApiKeyForm } from "./_components/create-api-key";
import { ApiKeyTable } from "./_components/api-key-table";

export default function ApiKey() {
  const { customerId } = useParams();
  return (
    <div className="space-y-4">
      {customerId != null && <CreateApiKeyForm customerId={customerId} />}
      {customerId != null && <ApiKeyTable />}
    </div>
  );
}
